import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { images } from "@/config/images";
import { site } from "@/config/site";

const navItems = [
  { label: "ホーム", to: "/" },
  { label: "商品・サービス", to: "/products" },
  { label: "MEGURIについて", to: "/about" },
  { label: "猪革・レザー", to: "/leather" },
  { label: "購入ページ", to: "/purchase" },
  { label: "お問い合わせ", to: "/contact" },
  { label: "アクセス", to: "/access" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200"
          : "bg-background-50/80 backdrop-blur-sm border-b border-transparent"
      }`}
    >
      <div className="flex items-center justify-between h-16 md:h-20 px-4 md:px-6">
        {/* ロゴ */}
        <Link to="/" className="flex items-center gap-2.5">
          <img
            src={images.logo}
            alt={`${site.companyName} ロゴ`}
            className="h-9 md:h-10 w-auto object-contain"
          />
          <div className="leading-tight">
            <span className="block font-heading font-bold text-foreground-950 text-sm md:text-base whitespace-nowrap">
              株式会社MEGURI
            </span>
            <span className="block text-[10px] md:text-xs text-foreground-500 whitespace-nowrap">
              佐世保市のジビエ食肉加工
            </span>
          </div>
        </Link>

        {/* デスクトップナビ */}
        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => {
            const active = location.pathname === item.to;
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                  active
                    ? "text-primary-700 bg-primary-100"
                    : "text-foreground-700 hover:text-primary-700 hover:bg-primary-50"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="hidden lg:block">
          <Link
            to="/purchase"
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-bold px-5 py-2.5 rounded-md whitespace-nowrap transition-colors"
          >
            <i className="ri-shopping-bag-line"></i>
            購入する
          </Link>
        </div>

        {/* ハンバーガー（モバイル） */}
        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100"
          aria-label="メニュー"
        >
          <i className={`text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {/* モバイルメニュー */}
      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50">
          <nav className="flex flex-col px-4 py-3 gap-1">
            {navItems.map((item) => {
              const active = location.pathname === item.to;
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`px-3 py-3 rounded-md text-base font-medium transition-colors ${
                    active
                      ? "text-primary-700 bg-primary-100"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
            <Link
              to="/purchase"
              className="mt-2 inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-base font-bold px-5 py-3 rounded-md whitespace-nowrap transition-colors"
            >
              <i className="ri-shopping-bag-line"></i>
              購入する
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}